
/* Audience « en train de regarder » — FONCTION PURE DU TEMPS (voir audience.mjs pour le pourquoi).
   ⛔ Ne jamais remplacer par Math.random() : le chiffre sauterait à chaque rechargement, et deux
      onglets de la même cliente afficheraient deux nombres différents. */
(function(){
  var el=document.getElementById('rpdpAudN'), enve=document.getElementById('rpdpAud');
  if(!el) return;

  var TAU=Math.PI*2, MIN=30, MAX=450;
  /* audience relative heure par heure, 00h → 23h. Profil mode/beauté : creux 4-5 h,
     reprise le matin, épaule à midi, montée le soir, pic 21 h, chute après minuit. */
  var PROFIL=[.34,.22,.14,.09,.06,.06,.09,.15,.24,.33,.41,.47,
              .52,.56,.53,.51,.54,.60,.68,.78,.90,1.00,.82,.58];
  /* entier -> [-1,1], déterministe et bien dispersé */
  function empreinte(n){
    n=(n^61)^(n>>>16); n=n+(n<<3); n=n^(n>>>4);
    n=Math.imul(n,0x27d4eb2d); n=n^(n>>>15);
    return ((n>>>0)/4294967295)*2-1;
  }
  /* bruit continu : deux tirages voisins reliés par une courbe en S → dérivée bornée */
  function octave(t,periode,graine){
    var x=t/periode, i=Math.floor(x), f=x-i, s=f*f*(3-2*f);
    return empreinte(i+graine)*(1-s)+empreinte(i+1+graine)*s;
  }
  /* interpolation Catmull-Rom circulaire : passe par chaque valeur horaire, sans angle */
  function profil(h){
    var i=Math.floor(h)%24, f=h-Math.floor(h);
    var a=PROFIL[(i+23)%24], b=PROFIL[i], c=PROFIL[(i+1)%24], d=PROFIL[(i+2)%24];
    return 0.5*(2*b+(c-a)*f+(2*a-5*b+4*c-d)*f*f+(3*b-a-3*c+d)*f*f*f);
  }
  var PMIN=1e9,PMAX=-1e9;
  for(var _i=0;_i<1440;_i++){var _v=profil(_i/60); if(_v<PMIN)PMIN=_v; if(_v>PMAX)PMAX=_v;}
  /* ── POIDS PAR PAYS ────────────────────────────────────────────────────────────────────
     L'HEURE est déjà propre à chaque visiteuse (getHours() = son fuseau). Ce qui manquait,
     c'est l'AMPLEUR : 300 personnes sur la fiche depuis la Thaïlande n'est pas crédible.
     ⚠ Ces poids sont des ESTIMATIONS ÉDITORIALES, pas des mesures — aucune donnée de trafic
       par pays n'est fiable ici (GA4 ne voit qu'une fraction des sessions). À retoucher
       librement : c'est la seule table à modifier. Plancher volontaire à 0,35 pour qu'aucun
       marché n'ait un compteur figé. */
  var POIDS={FR:1,US:.95,IT:.90,DE:.72,GB:.62,ES:.60,CA:.55,NL:.48,CH:.46,BE:.46,
             AT:.40,MX:.40,PL:.38,SE:.38,AU:.38,JP:.38,PT:.38,IE:.36,DK:.36,NO:.36,
             FI:.35,NZ:.35,TH:.35};
  var POIDS_DEFAUT=.50;
  function pays(){
    try{ if(window.Shopify&&Shopify.country) return String(Shopify.country).toUpperCase(); }catch(e){}
    try{
      var z=(Intl.DateTimeFormat().resolvedOptions().timeZone||'');
      var Z={'Europe/Paris':'FR','Europe/Rome':'IT','Europe/Berlin':'DE','Europe/Madrid':'ES',
             'Europe/London':'GB','Europe/Amsterdam':'NL','Europe/Brussels':'BE','Europe/Lisbon':'PT',
             'Europe/Vienna':'AT','Europe/Zurich':'CH','Europe/Dublin':'IE','Europe/Warsaw':'PL',
             'Europe/Stockholm':'SE','Europe/Copenhagen':'DK','Europe/Oslo':'NO','Europe/Helsinki':'FI',
             'Asia/Tokyo':'JP','Asia/Bangkok':'TH','America/Mexico_City':'MX','America/Toronto':'CA'};
      if(Z[z]) return Z[z];
      if(z.indexOf('America/')===0) return 'US';
      if(z.indexOf('Australia/')===0) return 'AU';
      if(z.indexOf('Pacific/Auckland')===0) return 'NZ';
    }catch(e){}
    return '';
  }
  function poidsPays(){ var c=pays(); return POIDS[c]!==undefined?POIDS[c]:POIDS_DEFAUT; }

  var SOCLE_BAS=133, SOCLE_HAUT=313;
  function audience(ms,poids){
    var w=(poids===undefined)?poidsPays():poids;
    var d=new Date(ms);
    var h=d.getHours()+d.getMinutes()/60+d.getSeconds()/3600;
    var socle=SOCLE_BAS+(SOCLE_HAUT-SOCLE_BAS)*((profil(h)-PMIN)/(PMAX-PMIN));
    var t=ms/1000;
    /* 4 octaves. Les deux dernières donnent le frémissement visible : sans elles le chiffre
       passait de 148 à 149 en 30 s, beaucoup trop figé.
       ⚠ ACCORD DES AMPLITUDES : pour un bruit lissé, la pente MAXIMALE d'une octave vaut
         3·A/P (et non 1,5·A/P — erreur de ma première version, qui produisait des écarts de 13).
         Somme des pentes = 0,19 + 0,50 + 1,30 + 0,50 = 2,49 /s → au plus ~7 entre deux
         rafraîchissements de 3 s. C'est ce qui garantit qu'on ne voit jamais de saut. */
    var houle=58*octave(t,900,17)+30*octave(t,180,911)+13*octave(t,30,4231)+2*octave(t,12,55127);
    var s=octave(t,5400,77);
    var poussee=s>0.55?((s-0.55)/0.45)*34:0;   /* nulle, puis monte en douceur : aucun à-coup */
    /* le poids comprime la plage vers le bas SANS toucher au plancher : un petit marché a des
       chiffres plus bas ET des variations plus petites — c'est ce que fait une vraie audience. */
    var n=Math.round(MIN+(socle+houle+poussee-MIN)*w);
    return n<MIN?MIN:(n>MAX?MAX:n);
  }
  var dernier=null, minuteur=null;
  var doux=!matchMedia('(prefers-reduced-motion: reduce)').matches;
  function peindre(){
    var n=audience(Date.now());
    if(n!==dernier){
      dernier=n;
      if(doux){ enve.classList.add('maj'); setTimeout(function(){ enve.classList.remove('maj'); },170); }
      setTimeout(function(){ el.textContent=n; }, doux?90:0);
    }
    /* cadence irrégulière : un compteur qui bat exactement toutes les 3 s se repère */
    minuteur=setTimeout(peindre, 2200+Math.random()*1500);
  }
  function relancer(){ clearTimeout(minuteur); if(!document.hidden) peindre(); }
  document.addEventListener('visibilitychange',relancer);   /* onglet caché : on cesse de calculer */
  dernier=audience(Date.now()); el.textContent=dernier;
  relancer();
  window.__lysAudience=audience;                            /* pour les contrôles */
})();
